import React from "react";
import ArticleListItem from "src/components/molecules/Blog/ArticleListItem";
import { usePagination } from "src/contexts/PaginationContext";

export interface ArticleListProps {}

const ArticleList: React.FC<ArticleListProps> = () => {
  const { data } = usePagination();
  return (
    <div className=" space-y-8">
      {data.map((post) => (
        <ArticleListItem key={post.id} post={post} />
      ))}
    </div>
  );
};

export default ArticleList;
